import {
    //faCat,
    //faFlower,
    //faMedal,
    faAngleDown,
    faLockAlt,
} from "@fortawesome/pro-light-svg-icons";
import { faCat, faMedal, faFlower } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Head from "next/head";
import React from "react";
import { SearchSpaces } from "../components/space/SearchSpaces";
// import SiteIcon from "../components/SiteIcon";
import { constants } from "../constants";
import CircuitBreakerAware from "../components/circuit-breaker/CircuitBreakerAware";
import Link from "next/link";
import CircuitBreakerWarning from "../components/circuit-breaker/CircuitBreakerWarning";
import Image from 'next/image';

import LUALPlatformBanner from '../public/LUAL_platform_banner_1.jpg';
import TributeTreeImage from '../public/Tribute tree_28x.jpg';
import FreeWillsImage from '../public/Free wills_LUAL platform.jpg';
import LUALSocialImage from '../public/LUAL_social posts_fb.jpg';
import { faAngleRight } from "@fortawesome/pro-regular-svg-icons";

function CreateSpaceButton({
    warningTextClassName,
}: {
    warningTextClassName: string;
}) {
    return (
        <CircuitBreakerAware>
            {({ enabled }) =>
                !enabled ? (
                    <Link href="/spaces/create">
                        <a className="z-10 btn-lg btn-primary focus:ring-offset-oswalds-500 focus:ring-white">
                            Create a place
                        </a>
                    </Link>
                ) : (
                    <div className="z-10 flex flex-col items-center">
                        <span className="btn-lg btn-primary opacity-50 mb-1 cursor-default">
                            Create a place
                        </span>
                        <CircuitBreakerWarning
                            className={`space-x-1 text-white ${warningTextClassName}`}>
                            <FontAwesomeIcon icon={faLockAlt} size="1x" />
                            <span className="font-semibold">Site locked</span>
                        </CircuitBreakerWarning>
                    </div>
                )
            }
        </CircuitBreakerAware>
    );
}

export default function Home() {
    return (
        <>
            <Head>
                <title>{constants.siteTitle}</title>
            </Head>
            <div className="bg-oswalds-800 pt-20 pb-4 px-4 flex flex-col items-center justify-center text-white relative">
                {/* <div className="absolute w-full pointer-events-none opacity-10 flex justify-center overflow-x-hidden">
                    <span className="mx-0 mb-60 lg:ml-96 lg:mb-40 z-0">
                        <SiteIcon size={256} />
                    </span>
                </div> */}
                <div className='absolute inset-0'>
                    <Image src={LUALPlatformBanner} layout='fill' objectFit='cover' priority alt='Background image of stars' />
                </div>
                <p className="text-4xl max-w-2xl mb-16 text-center leading-snug z-10">
                    A place to share the words you wanted to say and the memories you&apos;ll never forget.
                </p>
                <CreateSpaceButton warningTextClassName="text-white" />
                <FontAwesomeIcon
                    icon={faAngleDown}
                    size="3x"
                    className="text-white mt-24 z-10"
                />
            </div>
            <div className="bg-white px-4 pt-10 pb-16">
                <SearchSpaces />
            </div>
            <div className="bg-gray-50 px-4 py-12 sm:py-16">
                <div className="container mx-auto space-y-16 sm:flex sm:space-x-16 sm:space-y-0">
                    <div className="sm:w-1/3 flex flex-col items-start">
                        <FontAwesomeIcon
                            icon={faCat}
                            size="4x"
                            className="text-oswalds-600 mb-12"
                        />
                        <h3 className="text-oswalds-800 text-2xl text-left mb-4">
                            More than just people
                        </h3>
                        <p className="text-gray-700 text-left leading-relaxed">
                            Pets are part of the family too, and they leave a huge hole in our lives when we have to say goodbye. Keep them close by creating their own tribute page for you to treasure.
                        </p>
                    </div>
                    <div className="sm:w-1/3 flex flex-col items-start">
                        <FontAwesomeIcon
                            icon={faMedal}
                            size="4x"
                            className="text-yellow-400 mb-12"
                        />
                        <h3 className="text-oswalds-800 text-2xl text-left mb-4">
                            Raise money in memory
                        </h3>
                        <p className="text-gray-700 text-left leading-relaxed">
                            Mark an anniversary and keep your loved one’s star shining brightly by raising funds for a cause they cared about and sharing on their page to spread the word.
                        </p>
                    </div>
                    <div className="sm:w-1/3 flex flex-col items-start">
                        <FontAwesomeIcon
                            icon={faFlower}
                            size="4x"
                            className="text-loving-500 mb-12"
                        />
                        <h3 className="text-oswalds-800 text-2xl text-left mb-4">
                            Be part of our community
                        </h3>
                        <p className="text-gray-700 text-left leading-relaxed">
                            ....by discovering St Oswald&apos;s Hospice in-memory events and campaigns.
                        </p>
                    </div>
                </div>
            </div>
            <div className="bg-oswalds-700 px-4 py-4 lg:py-16">
                <div className="container mx-auto space-y-4 lg:flex lg:space-x-16 lg:space-y-0">
                    <div className='w-full lg:w-1/3 bg-white shadow-md'>
                        <a href='https://www.stoswaldsuk.org/who-we-care-for/' className='block group md:flex lg:block'>
                            <div className='h-48 md:w-48 md:h-auto md:flex-none lg:h-48 lg:w-auto lg:block relative'>
                                <Image
                                    src={LUALSocialImage}
                                    layout='fill'
                                    objectFit='cover'
                                    placeholder='blur'
                                    className='filter brightness-90 group-hover:brightness-100 transition ease-out duration-500'
                                    alt='Light up a Life banner' />
                            </div>
                            <div className='p-8 text-gray-700'>
                                <h3 className="text-2xl">
                                    About St Oswald&apos;s Hospice
                                </h3>
                                <p className='text-gray-600 mt-4 mb-2'>
                                    Light up a Life…a place to remember is brought to you by St Oswald&apos;s Hospice.
                                    As a registered charity, the hospice offers a range of free of charge services to support you and your loved ones.
                                </p>
                                <p className='text-right'>
                                    <FontAwesomeIcon icon={faAngleRight} size="1x" className="mr-2" />
                                    Read More
                                </p>
                            </div>
                        </a>
                    </div>
                    <div className='w-full lg:w-1/3 bg-white shadow-md'>
                        <a href='https://www.stoswaldsuk.org/get-involved/in-memory/dedicate-a-memory-leaf-on-our-tribute-tree/' className='block group md:flex lg:block'>
                            <div className='h-48 md:w-48 md:h-auto md:flex-none lg:h-48 lg:w-auto lg:block relative'>
                                <Image
                                    src={TributeTreeImage}
                                    layout='fill'
                                    objectFit='cover'
                                    placeholder='blur'
                                    className='filter brightness-90 group-hover:brightness-100 transition ease-out duration-500'
                                    alt='Photo of the tribute tree' />
                            </div>
                            <div className='p-8 text-gray-700'>
                                <h3 className="text-2xl mb-4">
                                    Open a Tribute Fund
                                </h3>
                                <p className='text-gray-600'>
                                    A Tribute Fund is a special way to commemorate the life of a loved one, with the option to dedicate a leaf bearing their name, on our beautiful Tribute tree in the hospice garden.
                                </p>
                                <p className='text-right'>
                                    <FontAwesomeIcon icon={faAngleRight} size="1x" className="mr-2" />
                                    Read More
                                </p>
                            </div>
                        </a>
                    </div>
                    <div className='w-full lg:w-1/3 bg-white shadow-md'>
                        <a href='https://www.stoswaldsuk.org/get-involved/in-memory/free-wills-for-charity/make-your-will-for-free/' className='block group md:flex lg:block'>
                            <div className='h-48 md:w-48 md:h-auto md:flex-none lg:h-48 lg:w-auto lg:block relative'>
                                <Image
                                    src={FreeWillsImage}
                                    layout='fill'
                                    objectFit='cover'
                                    placeholder='blur'
                                    className='filter brightness-90 group-hover:brightness-100 transition ease-out duration-500'
                                    alt='Free wills for charity banner' />
                            </div>
                            <div className='p-8 text-gray-700'>
                                <h3 className="text-2xl mb-4">
                                    Free Wills service
                                </h3>
                                <p className='text-gray-600'>
                                    Remembering St Oswald&apos;s in your Will is a simple and special way to make a real difference to our future. And with our Free Wills partnerships it doesn’t have to cost you anything in the here and now.
                                </p>
                                <p className='text-right'>
                                    <FontAwesomeIcon icon={faAngleRight} size="1x" className="mr-2" />
                                    Read More
                                </p>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </>
    );
}
